<template>
  <v-container>
    <v-dialog
      v-model="dialog"
      width="600"
      :fullscreen="fullScreenDialog"
      persistent
    >
      <!-- overlay-opacity="0.7" -->
      <v-card class="register-dialog">
        <v-row no-gutters>
          <v-col cols="10">
            <v-card-title class="py-1">
              {{ $t("label.register") }}
            </v-card-title>
          </v-col>
          <v-col cols="2">
            <v-btn
              color="primary"
              small
              icon
              @click="dialog = false"
              class="float-right mx-6 mt-1"
              ><v-icon>{{ mdiCloseThick }}</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-stepper v-model="register_form">
          <v-stepper-header>
            <v-stepper-step :complete="register_form > 1" step="1" class="py-1">
              {{ $t("label.register") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="register_form > 2" step="2" class="py-1">
              {{ $t("label.validate_short_code") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="register_form > 3" step="3" class="py-1">
              {{ $t("label.confirm_information") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="register_form > 4" step="4" class="py-1">
              {{ $t("label.complete") }}
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="py-1">
              <v-card class="mb-12" flat>
                <v-row dense>
                  <v-col>
                    <v-radio-group
                      v-model="Member.RegisterType"
                      row
                      dense
                      hide-details="auto"
                    >
                      <v-radio
                        :label="$t('label.email')"
                        value="EMAIL"
                        v-show="false"
                      ></v-radio>
                      <v-radio :label="$t('label.sms')" value="SMS"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row dense v-show="Member.RegisterType == 'EMAIL'">
                  <v-col>
                    <v-text-field
                      :label="$t('label.email')"
                      :rules="emailRules"
                      v-model="Member.Email"
                      type="email"
                      dense
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense v-show="Member.RegisterType == 'EMAIL'">
                  <v-col>
                    <v-text-field
                      :label="$t('label.first_name')"
                      v-model="Member.FirstName"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense v-show="Member.RegisterType == 'EMAIL'">
                  <v-col>
                    <v-text-field
                      :label="$t('label.last_name')"
                      v-model="Member.LastName"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense v-show="Member.RegisterType == 'SMS'">
                  <v-col>
                    <select-country
                      v-model="Country"
                      :change="afterCountry"
                      item-text="CntyName"
                      item-value="CntyCode"
                      :label="$t('label.country')"
                      hide-no-data
                      :onChange="afterCountry"
                    ></select-country>
                  </v-col>
                </v-row>
                <v-row dense v-show="Member.RegisterType == 'SMS'">
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('label.mobile_prefix')"
                      v-model="Member.MobilePrefix"
                      prefix="+"
                      type="text"
                      inputmode="decimal"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      :label="$t('label.mobile_no')"
                      v-model="Member.MobileNo"
                      type="text"
                      inputmode="decimal"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  @click="sendShortCode"
                  width="150px"
                  v-show="!isSendingShortCode"
                >
                  {{ $t("label.continue") }}<v-icon>{{ mdiArrowRight }}</v-icon>
                </v-btn>
                <v-progress-circular
                  :width="2"
                  color="primary"
                  indeterminate
                  v-show="isSendingShortCode"
                ></v-progress-circular>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="2" class="py-1">
              <v-card class="mb-12" flat>
                <v-row>
                  <v-col class="mx-auto">
                    {{
                      $t("message.input_short_code", {
                        type:
                          Member.RegisterType == "EMAIL"
                            ? $t("label.email")
                            : $t("label.sms"),
                      })
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="mx-auto">
                    <v-text-field
                      :label="$t('label.short_code')"
                      type="text"
                      inputmode="decimal"
                      v-model="Member.ShortCode"
                      prefix="FG-"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  @click="register_form = 1"
                  width="150px"
                  v-show="!isVerifyingShortCode"
                >
                  <v-icon>{{ mdiArrowLeft }}</v-icon
                  >{{ $t("label.back") }}
                </v-btn>

                <v-btn
                  color="primary"
                  @click="verifyShortCode"
                  width="150px"
                  v-show="!isVerifyingShortCode"
                >
                  {{ $t("label.continue") }}<v-icon>{{ mdiArrowRight }}</v-icon>
                </v-btn>
                <v-progress-circular
                  :width="2"
                  color="primary"
                  indeterminate
                  v-show="isVerifyingShortCode"
                ></v-progress-circular>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="3" class="py-1">
              <v-card flat>
                <v-row class="mx-auto" no-gutters>
                  <v-col class="mx-2 pt-3">
                    <v-radio-group
                      v-model="Member.Gender"
                      row
                      dense
                      hide-details
                      class="mt-0 pt-0"
                    >
                      <v-radio :label="$t('label.male')" value="M"></v-radio>
                      <v-radio :label="$t('label.female')" value="F"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row class="mt-0">
                  <v-col>
                    <v-text-field
                      :label="$t('label.first_name')"
                      v-model="Member.FirstName"
                      required
                      :rules="rules"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      :label="$t('label.last_name')"
                      v-model="Member.LastName"
                      required
                      :rules="rules"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      :label="$t('label.email')"
                      v-model="Member.Email"
                      type="email"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mx-auto" no-gutters>
                  <v-col>
                    <select-country
                      v-model="Country"
                      :change="afterCountry"
                      item-text="CntyName"
                      item-value="CntyCode"
                      :label="$t('label.country')"
                      :disabled="disabledBySms"
                      hide-no-data
                      :onChange="afterCountry"
                    ></select-country>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="3">
                    <v-text-field
                      :disabled="disabledBySms"
                      :label="$t('label.mobile_prefix')"
                      v-model="Member.MobilePrefix"
                      prefix="+"
                      type="text"
                      inputmode="decimal"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      :disabled="disabledBySms"
                      :label="$t('label.mobile_no')"
                      v-model="Member.MobileNo"
                      type="text"
                      inputmode="decimal"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col>
                    {{ $t("message.password_requirement") }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      :label="$t('label.password')"
                      :rules="passwordRules"
                      required
                      v-model="Member.Password"
                      :type="show1 ? 'text' : 'password'"
                      :append-icon="show1 ? mdiEye : mdiEyeOff"
                      @click:append="show1 = !show1"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      :label="$t('label.confirm_password')"
                      :rules="passwordRules"
                      required
                      v-model="Member.PasswordC"
                      :type="show2 ? 'text' : 'password'"
                      :append-icon="show2 ? mdiEye : mdiEyeOff"
                      @click:append="show2 = !show2"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col>
                    <v-checkbox
                      v-model="AgreedTermsOfService"
                      dense
                      hide-details
                      class="mt-0"
                    >
                      <template v-slot:label>
                        <div>
                          {{ $t("message.i_agree_to") }}
                          <v-tooltip bottom>
                            <template
                              v-slot:activator="{ on: onTermsOfService }"
                            >
                              <a
                                v-on="onTermsOfService"
                                @click.stop="toPage('term_of_service')"
                                >{{ $t("detail.term_of_service") }}</a
                              >
                            </template>
                            {{ $t("message.opens_new_window") }}
                          </v-tooltip>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col>
                    <v-checkbox
                      v-model="AgreedPrivacyPolicy"
                      dense
                      class="mt-0"
                    >
                      <template v-slot:label>
                        <div>
                          {{ $t("message.i_agree_to") }}
                          <v-tooltip bottom>
                            <template
                              v-slot:activator="{ on: onPrivacyPolicy }"
                            >
                              <a
                                v-on="onPrivacyPolicy"
                                @click.stop="toPage('privacy_policy')"
                                >{{ $t("detail.privacy_policy") }}</a
                              >
                            </template>
                            {{ $t("message.opens_new_window") }}
                          </v-tooltip>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  @click="register_form = 2"
                  width="150px"
                  v-show="!isRegistering"
                >
                  <v-icon>{{ mdiArrowLeft }}</v-icon
                  >{{ $t("label.back") }}
                </v-btn>
                <v-btn
                  color="primary"
                  @click="confirm()"
                  width="150px"
                  v-show="!isRegistering"
                >
                  {{ $t("label.confirm") }}<v-icon>{{ mdiPlay }}</v-icon>
                </v-btn>
                <v-progress-circular
                  :width="2"
                  color="primary"
                  indeterminate
                  v-show="isRegistering"
                ></v-progress-circular>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="4" class="py-1">
              <v-card class="my-16" flat>
                <v-row class="mx-3">
                  <v-col class="d-flex justify-center">
                    <p v-html="completedMessage"></p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="d-flex justify-center">
                    <v-btn
                      color="primary"
                      @click="dialog = false"
                      width="150px"
                      class="mx-5"
                      >{{ $t("label.complete") }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
  </v-container>
</template>

<script>
import {
  mdiArrowRight,
  mdiArrowLeft,
  mdiEye,
  mdiEyeOff,
  mdiPlay,
  mdiClose,
  mdiCloseThick,
} from "@mdi/js";
import {
  RegisterUser,
  VerifyByEmail,
  VerifyBySms,
  ValidateShortCode,
} from "@/api/publicServices";
import i18n from "../lang/lang";

export default {
  props: {
    value: Boolean,
  },
  components: {

  },
  mounted() {
    if (this.$route.query.SalesCode != undefined) {
      this.Member.SalesCode = this.$route.query.SalesCode;
      console.log(this.Member.SalesCode);
    }
    if (this.$route.query.CenterNo != undefined) {
      this.Member.CenterNo = this.$route.query.CenterNo;
    }
  },
  data() {
    return {
      rules: [
        (value) => !!value || i18n.t("label.required"),
        //(value) => (value && value.length >= 3) || "Min 3 characters",
      ],
      title_rules: [
        (value) => !!value || i18n.t("label.required"),
        (value) => (value && value.length >= 2) || "Min 3 characters",
      ],

      emailRules: [
        (value) => !!value || i18n.t("label.required"),
        (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return (
            pattern.test(value) ||
            i18n.t("message.invalid_field", { type: i18n.t("label.email") })
          );
        },
      ],

      passwordRules: [
        (value) => !!value || i18n.t("label.required"),
        (value) => {
          //const pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/
          const pattern = /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,30}$/;
          return (
            pattern.test(value) ||
            i18n.t("message.invalid_field", { type: i18n.t("label.password") })
          );
        },
      ],
      Member: {
        FirstName: "",
        LastName: "",
        MobilePrefix: "852",
        MobileNo: "",
        Gender: "",
        Email: "",
        RegisterType: "SMS",
        SalesCode: "",
        CenterNo: "",
        Country: "",
        VerificationID: "",
        ShortCode: "",
        Password: "",
        PasswordC: "",
      },
      // snackbar: false,
      // message: "",
      // message_color: "error",
      register_form: 1,
      Country: {
        CntyCode: "HK",
        CntyName: "HONG KONG",
        CnName: "香港",
        TelPrefix: "852",
      },
      isSendingShortCode: false,
      isVerifyingShortCode: false,
      isRegistering: false,
      menuOptions: [
        "self-pick-spot",
        "pricing",
        "news",
        "faq",
        "login",
        "locale",
      ],
      AgreedTermsOfService: false,
      AgreedPrivacyPolicy: false,
      show1: false,
      show2: false,

      snackBarMsg: {
        show: false,
        text: "",
        color: "red",
      },

      completedMessage: "",

      //svg icons
      mdiArrowRight,
      mdiArrowLeft,
      mdiEye,
      mdiEyeOff,
      mdiPlay,
      mdiClose,
      mdiCloseThick,
    };
  },
  computed: {
    disabledBySms: function () {
      return this.Member?.RegisterType == "SMS";
    },
    fullScreenDialog() {
      return localStorage.getItem("flutter") == "true";
    },
    dialog: {
      get() {
        console.log("get");
        return this.value;
      },
      set(value) {
        console.log("set");
        this.$emit("input", value);
      },
    },
  },
  methods: {
    resetSnackBar() {
      this.snackBarMsg.text = "";
      this.snackBarMsg.show = false;
      this.snackBarMsg.color = "red";
    },
    resetRegister() {
      this.Member.FirstName = "";
      this.Member.LastName = "";
      this.Member.MobilePrefix = "852";
      this.Member.MobileNo = "";
      this.Member.Gender = "";
      this.Member.Email = "";
      this.Member.RegisterType = "SMS";
      this.Member.SalesCode = "";
      this.Member.CenterNo = "";
      this.Member.Country = "";
      this.Member.VerificationID = "";
      this.Member.ShortCode = "";
      this.Member.Password = "";
      this.Member.PasswordC = "";

      this.register_form = 1;
      this.isSendingShortCode = false;
      this.isVerifyingShortCode = false;
      this.isRegistering = false;
    },
    getCountryCode() {
      if (this.country == null) {
        return "";
      }
      return this.country.CountryCode;
    },
    async sendShortCode(e) {
      e.preventDefault();
      this.isSendingShortCode = true;
      try {
        const response = await this.verify();
        this.resetSnackBar();
        if (response.data.isSuccess) {
          this.Member.VerificationID = response.data.Key;
          this.register_form = 2;
        } else {
          this.snackBarMsg.text = response.data.Msg;
          this.snackBarMsg.show = true;
        }
        this.isSendingShortCode = false;
      } catch (error) {
        console.log(error);
        this.isSendingShortCode = false;
      }
    },
    async verify() {
      if (this.Member.RegisterType == "EMAIL") {
        let data = {};
        data.FirstName = this.Member.FirstName;
        data.LastName = this.Member.LastName;
        data.Email = this.Member.Email;
        data.SalesCode = this.Member.SalesCode;
        data.CenterNo = this.Member.CenterNo;

        return await VerifyByEmail(data);
      } else {
        let data = {};
        data.MobilePrefix = this.Member.MobilePrefix;
        data.MobileNo = this.Member.MobileNo;
        data.SalesCode = this.Member.SalesCode;
        data.CenterNo = this.Member.CenterNo;

        return await VerifyBySms(data);
      }
    },
    async verifyShortCode() {
      this.isVerifyingShortCode = true;
      try {
        let data = {};
        data.VerificationID = this.Member.VerificationID;
        data.ShortCode = this.Member.ShortCode;
        const response = await ValidateShortCode(data);
        this.resetSnackBar();
        if (response.data.isSuccess) {
          this.register_form = 3;
        } else {
          this.snackBarMsg.text = response.data.Msg;
          this.snackBarMsg.show = true;
        }
        this.isVerifyingShortCode = false;
      } catch (error) {
        console.log(error);
        this.isVerifyingShortCode = false;
      }
    },
    async confirm() {
      this.isRegistering = true;
      this.Member.Country = this.Country.CntyCode;
      this.Member.AgreedTermsOfService = this.AgreedTermsOfService;
      this.Member.AgreedPrivacyPolicy = this.AgreedPrivacyPolicy;
      var isValid = await this.isValid();
      if (!isValid) {
        this.isRegistering = false;
        return;
      }

      let data = {};
      data["Member"] = this.Member;
      data["VerificationID"] = this.Member.VerificationID;
      data["CenterNo"] = this.Member.CenterNo;
      data["DeviceID"] = localStorage.getItem("FLUTTER_DEVICE_ID");
      data["DeviceToken"] = localStorage.getItem("FLUTTER_DEVICE_TOKEN");
      try {
        const response = await RegisterUser(data);

        this.resetSnackBar();
        console.log(response);
        if (response.data.isSuccess) {
          this.completedMessage = i18n.t("message.register_success", {
            member_no: response.data.Key,
          });
          this.register_form = 4;
          localStorage.setItem("site_member_no", response.data.Key);
        } else {
          this.snackBarMsg.text = response.data.Msg;
          this.snackBarMsg.show = true;
        }
        this.isRegistering = false;
      } catch (error) {
        console.log(error);

        this.isRegistering = false;
      }
    },
    isValid() {
      let isValid = true;
      let messages = [];
      this.resetSnackBar();
      if (this.Member.FirstName == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.first_name"),
          })
        );
        isValid = false;
      }

      if (this.Member.LastName == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.last_name"),
          })
        );
        isValid = false;
      }

      if (this.Member.Country == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.country"),
          })
        );
        isValid = false;
      }

      if (this.Member.RegisterType == "SMS") {
        if (this.Member.MobilePrefix == "") {
          messages.push(
            i18n.t("message.is_empty", {
              type: i18n.t("label.mobile_prefix"),
            })
          );
          isValid = false;
        }

        if (this.Member.MobileNo == "") {
          messages.push(
            i18n.t("message.is_empty", {
              type: i18n.t("label.mobile_no"),
            })
          );
          isValid = false;
        }
      } else {
        if (this.Member.Email == "") {
          messages.push(
            i18n.t("message.is_empty", {
              type: i18n.t("label.email"),
            })
          );
          isValid = false;
        }
      }

      if (this.Member.VerificationID == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.verification_id"),
          })
        );
        isValid = false;
      }

      if (this.Member.ShortCode == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.short_code"),
          })
        );
        isValid = false;
      }

      if (this.Member.Password == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.password"),
          })
        );
        isValid = false;
      }

      if (this.Member.Password != this.Member.PasswordC) {
        messages.push(
          i18n.t("message.not_match", {
            type: i18n.t("label.password"),
          })
        );
        isValid = false;
      }

      if (!this.Member.AgreedTermsOfService) {
        messages.push(
          i18n.t("message.agree_first", {
            item: i18n.t("detail.term_of_service"),
          })
        );
        isValid = false;
      }

      if (!this.Member.AgreedPrivacyPolicy) {
        messages.push(
          i18n.t("message.agree_first", {
            item: i18n.t("detail.privacy_policy"),
          })
        );
        isValid = false;
      }
      if (!isValid) {
        this.snackBarMsg.text = messages.join("\n\r");
        this.snackBarMsg.show = true;
      }

      return isValid;
    },
    afterCountry() {
      this.Member.MobilePrefix = "";
      if (this.Country != null) {
        this.Member.MobilePrefix = this.Country.TelPrefix;
      }
    },
    toHome() {
      this.$router.replace({ name: "home" });
    },
    openLoginDialog() {
      this.$refs.mainmenu.openLoginDialog();
    },
    toPage(page) {
      let routeData = this.$router.resolve({ name: page });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped>
/* @media only screen and (max-width: 959px) {
  .v-stepper:not(.v-stepper--vertical) >>> .v-stepper__label {
    display: flex !important;
  }
} */

.register-dialog >>> .v-stepper__header {
  height: 42px !important;
}
</style>
